import { render, staticRenderFns } from "./ConfigEmailHabeasData.vue?vue&type=template&id=3301b504&scoped=true"
import script from "./ConfigEmailHabeasData.vue?vue&type=script&lang=js"
export * from "./ConfigEmailHabeasData.vue?vue&type=script&lang=js"
import style0 from "./ConfigEmailHabeasData.vue?vue&type=style&index=0&id=3301b504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3301b504",
  null
  
)

export default component.exports